import { useState } from "react";
import { submitLead } from "../lib/leadsApi";

export default function LeadFormModal({ book, open, onClose }) {
  const [status, setStatus] = useState("idle");
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [readUrl, setReadUrl] = useState(null);

  if (!open) return null;

  async function handleSubmit(event) {
    event.preventDefault();
    setStatus("submitting");

    const form = new FormData(event.currentTarget);

    const { data, error } = await submitLead(book, {
      firstName: form.get("firstName"),
      lastName: form.get("lastName"),
      email: form.get("email"),
      phone: form.get("phone"),
    });

    if (error) {
      setStatus("error");
      return;
    }

    setDownloadUrl(data.pdfUrl);
    setReadUrl(data.readUrl);
    setStatus("done");
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="relative w-full max-w-lg overflow-y-auto rounded-xl bg-white p-6 shadow-xl sm:p-8 max-h-[90vh]">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-md border border-zinc-200 text-zinc-500 hover:bg-zinc-50"
        >
          ✕
        </button>

        {status === "done" ? (
          <div className="py-6 text-center">
            <h3 className="text-2xl font-bold text-zinc-900">You're all set!</h3>
            <p className="mt-2 text-zinc-600">
              We've emailed you the link to "{book.title}". You can also
              jump straight in below:
            </p>
            <div className="mt-5 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
              {readUrl && (
                <a
                  href={readUrl}
                  className="inline-block rounded-md bg-sky-500 px-6 py-3 font-semibold text-white hover:bg-sky-600"
                >
                  Read It Now
                </a>
              )}
              {downloadUrl && (
                <a
                  href={downloadUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block rounded-md border border-zinc-300 px-6 py-3 font-semibold text-zinc-700 hover:bg-zinc-50"
                >
                  Download PDF
                </a>
              )}
            </div>
          </div>
        ) : (
          <>
            <h3 className="text-2xl font-bold text-zinc-900">
              Want a <span className="bg-amber-300 px-1">FREE</span> Copy of My
              Book?
            </h3>
            <p className="mt-2 text-zinc-600">
              Simply enter your information below so we will know where to send
              it!
            </p>

            <form onSubmit={handleSubmit} className="mt-6 space-y-4">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <label className="mb-1 block text-sm font-medium text-zinc-800">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="firstName"
                    required
                    className="w-full rounded-md border border-zinc-300 px-3 py-2"
                  />
                </div>
                <div>
                  <label className="mb-1 block text-sm font-medium text-zinc-800">
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    name="lastName"
                    required
                    className="w-full rounded-md border border-zinc-300 px-3 py-2"
                  />
                </div>
              </div>

              <div>
                <label className="mb-1 block text-sm font-medium text-zinc-800">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full rounded-md border border-zinc-300 px-3 py-2"
                />
              </div>

              <div>
                <label className="mb-1 block text-sm font-medium text-zinc-800">
                  Phone <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  placeholder="+1 (XXX) XXX-XXXX"
                  className="w-full rounded-md border border-zinc-300 px-3 py-2"
                />
              </div>

              <button
                type="submit"
                disabled={status === "submitting"}
                className="w-full rounded-md bg-sky-500 px-6 py-3 font-semibold text-white hover:bg-sky-600 disabled:opacity-60"
              >
                {status === "submitting" ? "Sending…" : "SEND ME THE FREE COPY"}
              </button>

              {status === "error" && (
                <p className="text-sm text-red-600">
                  Something went wrong — please try again.
                </p>
              )}

              <p className="text-center text-xs text-zinc-500">
                Privacy Policy: We hate spam and promise to keep your
                information safe.
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
